import { Wrap, WrapItem, Button, Flex, Heading, Radio, RadioGroup, Select, Text, Textarea } from "@chakra-ui/react";

const languageOptions = [
  { value: 'en', label: 'English' },
  { value: 'ar', label: 'Arabic' },
  { value: 'bg', label: 'Bulgarian' },
  { value: 'cs', label: 'Czech' },
  { value: 'da', label: 'Danish' },
  { value: 'de', label: 'German' },
  { value: 'el', label: 'Greek' },
  { value: 'es', label: 'Spanish' },
  { value: 'fi', label: 'Finnish' },
  { value: 'fr', label: 'French' },
  { value: 'hi', label: 'Hindi' },
  { value: 'hr', label: 'Croatian' },
  { value: 'id', label: 'Indonesian' },
  { value: 'it', label: 'Italian' },
  { value: 'ja', label: 'Japanese' },
  { value: 'ko', label: 'Korean' },
  { value: 'ms', label: 'Malay' },
  { value: 'nl', label: 'Dutch' },
  { value: 'pl', label: 'Polish' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'ro', label: 'Romanian' },
  { value: 'ru', label: 'Russian' },
  { value: 'sk', label: 'Slovak' },
  { value: 'sv', label: 'Swedish' },
  { value: 'ta', label: 'Tamil' },
  { value: 'tl', label: 'Tagalog' },
  { value: 'tr', label: 'Turkish' },
  { value: 'uk', label: 'Ukrainian' },
  { value: 'zh', label: 'Chinese' }
];

function VideoSettingsForm({ values, onChange, aiTargetAudiences = [] }) {

  const handleAudienceClick = (audience) => {
    const current = values.targetAudience || '';
    const trimmed = current.trim();
    const needsComma = trimmed && !trimmed.endsWith(',');
    const newValue = `${trimmed}${needsComma ? ',' : ''} ${audience}, `.replace(/\s*,\s*$/, ', ');
    onChange({ ...values, targetAudience: newValue });
  };

  return (
    <Flex direction="column" gap={6} px={4} width="600px">
      <Heading fontSize="2xl">Video settings</Heading>

      {/* Aspect Ratio and Duration */}
      <Flex direction="row" gap={6}>
        {/* Aspect Ratio */}
        <Flex direction="column" gap={2} flex={1}>
          <Text fontWeight="bold">Aspect ratio</Text>
          <RadioGroup
            onChange={(val) => onChange({ ...values, aspectRatio: val })}
            value={values.aspectRatio}
            colorScheme='brand'
          >
            <Flex gap={4}>
              <Radio value="9:16">9:16</Radio>
              <Radio value="16:9">16:9</Radio>
              <Radio value="1:1">1:1</Radio>
            </Flex>
          </RadioGroup>
        </Flex>

        {/* Duration */}
        <Flex direction="column" gap={2} flex={1}>
          <Text fontWeight="bold">Duration</Text>
          <RadioGroup
            onChange={(val) => onChange({ ...values, duration: val })}
            value={values.duration}
            colorScheme='brand'
          >
            <Flex gap={4}>
              <Radio value="15">15s</Radio>
              <Radio value="30">30s</Radio>
              <Radio value="60">60s</Radio>
            </Flex>
          </RadioGroup>
        </Flex>
      </Flex>

      {/* Language */}
      <Flex direction="column" gap={4}>
        <Text fontWeight="bold">Language</Text>
        <Select
          name="language"
          maxWidth="200px"
          borderRadius="md"
          size="sm"
          value={values.language}
          onChange={(e) => onChange({ ...values, language: e.target.value })}
        >
          {languageOptions.map(lang => (
            <option key={lang.value} value={lang.value}>
              {lang.label}
            </option>
          ))}
        </Select>
      </Flex>

      {/* Target Audience */}
      <Flex direction="column" gap={4}>
        <Text fontWeight="bold">Target audience</Text>
        <Textarea
          value={values.targetAudience}
          onChange={(e) => onChange({ ...values, targetAudience: e.target.value })}
          placeholder="e.g. outdoor lover"
          size="sm"
          borderRadius="md"
          rows={6}
        />

        {aiTargetAudiences?.length > 0 && (
          <Wrap>
            {aiTargetAudiences?.map((audience, index) => (
              <WrapItem key={index}>
                <Button
                  size="xs"
                  borderRadius={'md'}
                  colorScheme="gray"
                  variant={'outline'}
                  onClick={() => handleAudienceClick(audience)}
                >
                  {audience}
                </Button>
              </WrapItem>
            ))}
          </Wrap>
        )}
      </Flex>
    </Flex>
  );
}

export default VideoSettingsForm;